import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import { ErrorCode } from '@ancon/wildcat-types'

import HeadingText from '../../app/components/HeadingText'
import useAppSelector from '../../../store/hooks/useAppSelector'
import { appErrorModalConfigSelector } from '../../app/store/appSelectors'
import { InformativeError } from '../../app/types'

import styles from './CheckoutInvalidItemsList.module.scss'

type InvalidDataErrorConfig =
  InformativeError<ErrorCode.RequestDataNotValid> | null

export default function CheckoutInvalidItemsList() {
  const { t } = useTranslation('common')

  const invalidDataErrorConfig: InvalidDataErrorConfig = useAppSelector(
    appErrorModalConfigSelector,
  )

  const unavailableItems = invalidDataErrorConfig?.additionalData || []

  if (!unavailableItems.length) return null

  return (
    <div className={styles.unavailableProductsList}>
      <HeadingText
        as="h3"
        size="h3"
        className={styles.unavailableProductsTitle}
      >
        {t('errors.checkoutRequestDataNotValid.unavailableItemsListTitle')}
      </HeadingText>
      <ul className={styles.productList}>
        {unavailableItems.map(item => (
          <li key={item.variantId} className={styles.productItem}>
            {item.productName}
          </li>
        ))}
      </ul>
    </div>
  )
}
